var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"tag":"a","href":_vm.url,"target":"_blank","icon-right":"guitar-pick"}},[_vm._v("\n  "+_vm._s(_vm.options.filename)+" · "+_vm._s(_vm.options.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }